import { APP_INITIALIZER, ErrorHandler, HostListener, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideHttpClient } from '@angular/common/http';
import { OrientationModule } from './services/General/Orientation/orientation.module';
import { AngularSvgIconModule, SvgIconRegistryService } from 'angular-svg-icon';
import { JoyrideModule } from 'ngx-joyride';
import { PermissionsModule } from './services/General/Permissions/permissions.module';
import { FullScreenMediaModalModule } from './components/ui/modal/full-screen-media-modal/full-screen-media-modal.module';

import * as Sentry from "@sentry/angular";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    OrientationModule,
    PermissionsModule,
    AngularSvgIconModule.forRoot(),
    // AngularSvgIconPreloaderModule.forRoot({
    // 	configUrl: './assets/json/icons.json',
    // }),
    JoyrideModule.forRoot(),
    FullScreenMediaModalModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(),
    SvgIconRegistryService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    // InspectionService,
    // StylesService,
    // Platform,
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  isKeyboardVisible = false;

  @HostListener('window:resize', [])
  onResize() {
    const viewportHeight = window.innerHeight;
    const documentHeight = document.documentElement.clientHeight;

    // Check if the viewport height is significantly smaller than the document height
    this.isKeyboardVisible = documentHeight - viewportHeight > 150;
  }
  constructor(trace: Sentry.TraceService) { }
}
